export var AD_EVENT;
(function (AD_EVENT) {
    AD_EVENT["AD_CLOSE"] = "ad_close";
    AD_EVENT["AD_ERROR"] = "ad_error";
    AD_EVENT["AD_OPEN"] = "ad_open";
    AD_EVENT["CONTENT_PAUSE"] = "pause_content";
    AD_EVENT["CONTENT_RESUME"] = "resume_content";
    AD_EVENT["REWARDED"] = "rewarded";
})(AD_EVENT || (AD_EVENT = {}));
export var GAME_EVENT;
(function (GAME_EVENT) {
    GAME_EVENT["START"] = "game_start";
    GAME_EVENT["RESTART"] = "game_restart";
    GAME_EVENT["PAUSE"] = "pause_content";
    GAME_EVENT["RESUME"] = "resume_content";
    GAME_EVENT["NOTIFICATION"] = "game_notification";
})(GAME_EVENT || (GAME_EVENT = {}));
export var HTML_EVENT;
(function (HTML_EVENT) {
    HTML_EVENT["RESIZE"] = "resize";
})(HTML_EVENT || (HTML_EVENT = {}));
export var PARENT_EVENT;
(function (PARENT_EVENT) {
    PARENT_EVENT["AD_REQUEST"] = "ad_request";
    PARENT_EVENT["AD_REQUEST_REWARDED"] = "ad_request_rewarded";
    PARENT_EVENT["READY"] = "ready";
})(PARENT_EVENT || (PARENT_EVENT = {}));
var EventHandler = /** @class */ (function () {
    function EventHandler() {
    }
    EventHandler.getInstance = function () {
        if (!this._instance) {
            this._instance = new EventHandler();
        }
        return this._instance;
    };
    EventHandler.prototype.load = function () { };
    EventHandler.prototype.on = function (event, listener, parent) {
        if (parent === void 0) { parent = false; }
        try {
            if (parent) {
                window.addEventListener("message", function (e) {
                    if (e.data !== event)
                        return;
                    listener(e);
                }, true);
                return;
            }
            window.addEventListener(event, listener, true);
        }
        catch (_a) { }
    };
    EventHandler.prototype.once = function (event, listener, parent) {
        if (parent === void 0) { parent = false; }
        try {
            if (parent) {
                window.addEventListener("message", function (e) {
                    if (e.data !== event)
                        return;
                    listener(e);
                }, { once: true });
                return;
            }
            window.addEventListener(event, listener, {
                once: true,
            });
        }
        catch (_a) { }
    };
    EventHandler.prototype.remove = function (event, listener, parent) {
        if (parent === void 0) { parent = false; }
        try {
            if (parent) {
                window.removeEventListener("message", listener, true);
                return;
            }
            window.removeEventListener(event, listener, true);
        }
        catch (_a) { }
    };
    EventHandler.prototype.send = function (event, parent, detail) {
        if (parent === void 0) { parent = true; }
        try {
            if (parent) {
                window.parent.postMessage(event, "*");
                return;
            }
            window.dispatchEvent(new CustomEvent(event, { detail: detail }));
        }
        catch (_a) { }
    };
    EventHandler.AD_EVENT = AD_EVENT;
    EventHandler.GAME_EVENT = GAME_EVENT;
    EventHandler.HTML_EVENT = HTML_EVENT;
    EventHandler.PARENT_EVENT = PARENT_EVENT;
    return EventHandler;
}());
export default EventHandler;
